import { render, staticRenderFns } from "./homeReadCraouser.vue?vue&type=template&id=4fd13cb4&scoped=true&"
import script from "./homeReadCraouser.vue?vue&type=script&lang=ts&"
export * from "./homeReadCraouser.vue?vue&type=script&lang=ts&"
import style0 from "./homeReadCraouser.vue?vue&type=style&index=0&id=4fd13cb4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fd13cb4",
  null
  
)

export default component.exports